import React from 'react';
import { toJS } from 'mobx';
import {
  Modal, Form, Button, Spin, Row, Col, Icon
} from 'antd';

class ApplyApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // visible: props.visible,
      // title: props.title,
      visible: false,
      loading: false,
      title: props.applyModal.title,
      applyModal: props.applyModal,
      formData: {},
      applyApps: props.applyApps,
      appInfo: props.applyModal.appInfo || [],
      showAllName: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      applyApps: nextProps.applyApps,
      applyModal: nextProps.applyModal,
      visible: nextProps.applyModal.visible,
      title: nextProps.applyModal.title,
      loading: nextProps.applyModal.loading,
      appInfo: nextProps.applyModal.appInfo || [],
    });
  }

  setTriggerValue() {
    //todo
  }

  render() {
    let { title, visible, loading, applyApps, appInfo, showAllName } = this.state;
    appInfo = toJS(appInfo);
    return (
      <Modal
        title={title} visible={visible}
        className='app-apply-modal'
        footer={[
          <Button key="1" type='gost' onClick={this.handleCancel.bind(this)}>返回</Button>
        ]}
        onCancel={this.handleCancel.bind(this)}
      >
        <Spin tip="正在打包应用" spinning={loading}>
          <Row className='app-apply-list'>
            <Col span={4} offset={1}>
              获取应用:
            </Col>
            <Col span={19}>
              {
                appInfo && appInfo.map((item, index) => {
                  return (
                    <div>
                      {
                        (showAllName || index === 0) && (
                          <div className='app-apply-list-name'
                            key={item.appId}
                            onClick={() => {
                              this.setState({ showAllName: !showAllName });
                            }}>
                            <span>{item.appName}</span>
                            {
                              appInfo.length > 1 && index === 0 && (
                                <div className='app-apply-list-more'>
                                  <span>更多</span>
                                  {showAllName ? <Icon type="up-circle" /> : <Icon type="down-circle" />}
                                </div>
                              )
                            }
                          </div>
                        )
                      }
                    </div>
                  )
                })
              }
            </Col>
          </Row>
          <Row>
            <Col span={4} offset={1}>
              下载地址:
            </Col>
            <Col span={19}>
              <div>
                <a className='app-apply-download' href='/files/ecfile/ecology.zip' target='_blank'> 客户端（首次使用请先下载客户端）</a>
              </div>
              <div>
                <a className='app-apply-download' href={applyApps.flow4App}>应用（含应用包）</a>
              </div>
              <div>
                <a className='app-apply-download' href='/files/ecfile/使用说明文件.docx' target='_blank'>使用说明文档</a>
              </div>
            </Col>
          </Row>
        </Spin>
      </Modal>

    )
  }
  // <div>
  //  <a className='app-apply-download' href={applyApps.flow4AppAll}>完整（含云商店客户端、应用包）</a>
  // </div>
  handleCancel() {
    typeof this.props.handleCloseModal === 'function' && this.props.handleCloseModal();
  }
}

export default Form.create()(ApplyApp)


// WEBPACK FOOTER //
// ./src/components/util/AppApplyModal.js